import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getConfig } from "@jti/fe-common";
import { CasPurposesApi } from "@jti/rest-api";
import { replacePlaceholdersWithLinks } from "@jti/ui";
import { useUser } from "../../hooks/useUser";
import Checkbox from "../checkbox/Checkbox";
const ConsentCheckbox = ({ displayConsent, formConfig }) => {
    const config = getConfig();
    const [checkboxes, setCheckboxes] = useState([]);
    const { isLoggedIn } = useUser();
    const isInvalid = (displayConsent === "onlyLoggedIn" && !isLoggedIn) || (displayConsent === "onlyNotLoggedIn" && isLoggedIn);
    useEffect(() => {
        if (!isInvalid) {
            CasPurposesApi.init()
                .getPurposesByStep("contact_form")
                .then((response) => {
                setCheckboxes(response);
            });
        }
    }, []);
    if (isInvalid) {
        return null;
    }
    return (_jsx(_Fragment, { children: checkboxes.map((element, key) => (_jsx(Checkbox, { id: element.id, label: replacePlaceholdersWithLinks(element.description, config.ONE_TRUST_DYNAMIC_LINKS ?? []), validationRules: {
                required: element.mandatory,
            }, checked: element.default, formConfig: formConfig }, key))) }));
};
export default ConsentCheckbox;
//# sourceMappingURL=ConsentCheckbox.js.map